import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'pv-recruitement-profile-step',
    templateUrl: './recruitement-profile-step.component.html',
    styleUrls: ['./recruitement-profile-step.component.scss'],
    standalone: false
})
export class RecruitementProfileStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
